import { NoPostsPropTypes } from "./propTypes";
import "./styles.scss";

const NoPosts = ({ category, background = true }) => {
  const getContent = () => {
    let content = "Stay tuned for updates and engaging content coming soon!";

    if (category && category !== "All") {
      content = `There are no posts under the category <b>${category}</b>, please check back later for updates.`;
    }

    return content;
  };

  const bgClass = background ? "noPosts--bg" : "";

  return (
    <div className={`noPosts mt-16 ${bgClass}`}>
      <p className="paragraph mb-0 text-white" dangerouslySetInnerHTML={{ __html: getContent() }} />
    </div>
  );
};

NoPosts.propTypes = NoPostsPropTypes;

export default NoPosts;
